import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { ClientCollection, RouteHttpVerb, AbstractPostCollection } from "@devowl-wp/utils";
import { request } from "../utils";
import { TcfVendorConfigurationModel } from ".";
class TcfVendorConfigurationCollection extends AbstractPostCollection {
    constructor(store){
        super();
        this.store = store;
    }
    instance(response) {
        return new TcfVendorConfigurationModel(this).fromResponse(response);
    }
}
TcfVendorConfigurationCollection = _ts_decorate([
    ClientCollection.annotate({
        path: "/rcb-tcf-vendor-conf",
        singlePath: "/rcb-tcf-vendor-conf/:id",
        namespace: "wp/v2",
        methods: [
            RouteHttpVerb.GET
        ],
        request
    }),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof TcfStore === "undefined" ? Object : TcfStore
    ])
], TcfVendorConfigurationCollection);
export { TcfVendorConfigurationCollection };
